import StrictObj from './strict-obj'

// name is a @user marker
// like: I and @sally doing #something
const IS_NAME = /^[\w.-]+$/

// ref is a /user part of url, examples:
//  - https://www.youtube.com/channel/UC5Ja2SmN9mUn-0fYLX8ecxg
//  - https://www.facebook.com/Gleamapp
//  - https://www.facebook.com/search/people/?q=Hello+There
//  - https://helloyello.tumblr.com
const IS_REF = /^[\w.-]+$/
const LIKE_YB_HASH_REF = /^(UC)?[\w-]{22}$/
const IS_YB_HASH_REF = /^[\w-]{22}$/ // poller trims "UC" because of some reason
const IS_FB_NUM_REF = /^\d+$/
const IS_FB_REF = /^[\w.%*+-]+$/

// hashtag can be written in any language
// and start from any character
// valid instagram thing: #💎#1
const IS_TAG = /^\S+$/

// https://regex101.com/r/03oEA6/6
// https://www.debuggex.com/r/UxkX07mRxV0cLth7
const LINKS = /\b((?:https?:\/\/\S*[^\s,.!"']+)|(?:\w(?:[\w-]+\.)+\w+\/(?:\S*[^\s,.!"']+)?)|(?:www\.(?:[\w-]+\.)+\w+(?:\/\S*[^\s,.!"']+)?))/gi

// For some reason, youtube turned off all @references
const YOUTUBE_NAMES = null
// https://regex101.com/r/4bEB6m/3
const INSTAGRAM_NAMES = /\B@([_0-9a-z](?:\.?[_0-9a-z]+)*)/ig
// https://regex101.com/r/Gh0NLJ/3
const FACEBOOK_NAMES = /\B@([0-9a-z](?:\.?[0-9a-z]+)*)/ig
// https://regex101.com/r/BYjSIn/2
const VIMEO_NAMES = /\B@([0-9a-z]+)/ig
// https://regex101.com/r/4UM40p/1
const VINE_NAMES = /\B@([0-9a-z](?:\.?[0-9a-z]+)*)/ig
// https://regex101.com/r/Vi8DIO/2
const SOUNDCLOUD_NAMES = /\B@([0-9a-z](?:[_-]*[0-9a-z]+)*)/ig
// https://regex101.com/r/Jkufdz/1
const TWITTER_NAMES = /\B@([_0-9a-z]+)/ig
// https://regex101.com/r/ppnn7E/1
const PINTEREST_NAMES = /\B@([0-9a-z]+)/ig
// https://regex101.com/r/1XXa6D/2
const TUMBLR_NAMES = /\B@([0-9a-z](?:-?[0-9a-z]+)*)/ig

// hosts
const IS_YOUTUBE    = /^(https?:)?\/\/(www\.)?youtu(\.be|be\.\w+)/i
const IS_INSTAGRAM  = /^(https?:)?\/\/(www\.)?instagram\.\w+/i
const IS_FACEBOOK   = /^(https?:)?\/\/(www\.)?facebook\.\w+/i
const IS_VIMEO      = /^(https?:)?\/\/(www\.)?vimeo\.\w+/i
const IS_VINE       = /^(https?:)?\/\/(www\.)?vine\.\w+/i
const IS_SOUNDCLOUD = /^(https?:)?\/\/(www\.)?soundcloud\.\w+/i
const IS_TWITTER    = /^(https?:)?\/\/(www\.)?twitter\.\w+/i
const IS_PINTEREST  = /^(https?:)?\/\/(www\.)?pinterest\.\w+/i
const IS_TUMBLR     = /^(https?:)?\/\/(www\.)?([\w-]+\.)?tumblr\.\w+/i

export default StrictObj({
  IS_NAME,
  IS_REF,
  LIKE_YB_HASH_REF,
  IS_YB_HASH_REF,
  IS_FB_NUM_REF,
  IS_FB_REF,
  IS_TAG,

  LINKS,

  YOUTUBE_NAMES,
  INSTAGRAM_NAMES,
  FACEBOOK_NAMES,
  VIMEO_NAMES,
  VINE_NAMES,
  SOUNDCLOUD_NAMES,
  TWITTER_NAMES,
  PINTEREST_NAMES,
  TUMBLR_NAMES,

  IS_YOUTUBE,
  IS_INSTAGRAM,
  IS_FACEBOOK,
  IS_VIMEO,
  IS_VINE,
  IS_SOUNDCLOUD,
  IS_TWITTER,
  IS_PINTEREST,
  IS_TUMBLR
})
